// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___1UWoS","header":"header___2OSYT","blink":"blink___2GkcB"};